import SVGPointShape from './SVGPointShape'

const oneDecimal = n => parseInt(n * 10) / 10
export default class SVGShape {
  constructor () { this.points = [] }

  current () { return this.points.slice(-1)[0] }

  addPoint (x, y) { this.points.push(new SVGPointShape(x, y)) }

  setLeft (x, y) { this.current().setLeft(x, y) }

  setRight (x, y) { this.current().setRight(x, y) }

  toSVG (rounded = true) {
    // first vertex
    const points = this.points
    const first = points[0].getPoint()
    const x = rounded ? oneDecimal(first.x) : first.x
    const y = rounded ? oneDecimal(first.y) : first.y
    let svg = `M${x}${y < 0 ? y : ` ${y}`}`

    // rest of the shape
    for (let p = 1; p < points.length; p++) {
      // since we have to work with point pairs, get "prev" and "current"
      const prev = points[p - 1]
      const curr = points[p]
      // if both are plain, LineTo. Otherwise, Cubic bezier.
      if (curr.isPlain() && prev.isPlain()) {
        const lx = rounded ? oneDecimal(curr.getPoint().x) : curr.getPoint().x
        const ly = rounded ? oneDecimal(curr.getPoint().y) : curr.getPoint().y
        svg += `L${lx}${ly < 0 ? ly : ` ${ly}`}`
      } else {
        const cx1 = rounded ? oneDecimal(prev.getRight().x) : prev.getRight().x
        const cy1 = rounded ? oneDecimal(prev.getRight().y) : prev.getRight().y
        const cx2 = rounded ? oneDecimal(curr.getLeft().x) : curr.getLeft().x
        const cy2 = rounded ? oneDecimal(curr.getLeft().y) : curr.getLeft().y
        const x2 = rounded ? oneDecimal(curr.getPoint().x) : curr.getPoint().x
        const y2 = rounded ? oneDecimal(curr.getPoint().y) : curr.getPoint().y
        svg += `C${cx1}${cy1 < 0 ? cy1 : ` ${cy1}`
          }${cx2 < 0 ? cx2 : ` ${cx2}`}${cy2 < 0 ? cy2 : ` ${cy2}`
          }${x2 < 0 ? x2 : ` ${x2}`}${y2 < 0 ? y2 : ` ${y2}`}`
      }
    }
    return `${svg}Z`
  }
}
